import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { LandingComponent } from './landing/landing.component';
import { PricingComponent } from './pricing/pricing.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { FilterComponent } from './filter/filter.component';
import { RequestLogsComponent } from './request-logs/request-logs.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { RegisterComponent } from './register/register.component';
import { AuthGuard } from './shared/guard/auth.guard';
import { NewPropertyComponent } from './new-property/new-property.component';
import { TemplateEditorComponent } from './template-editor/template-editor.component';
import { PreviewPageComponent } from './preview-page/preview-page.component';
import { FeaturesComponent } from './features/features.component';
import { SupportComponent } from './support/support.component';
import { WhychooseusComponent } from './whychooseus/whychooseus.component';
import { NewsComponent } from './news/news.component';
import { WarmUpComponent } from './warm-up/warm-up.component';
import { GetStartedComponent } from './get-started/get-started.component';
import { TrackingComponent } from './tracking/tracking.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { FirstTimeSetupComponent } from './first-time-setup/first-time-setup.component';


const routes: Routes = [
  // { path: '', redirectTo: '/dashboard', pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'dashboard', component: DashboardPageComponent, canActivate: [AuthGuard] },
  { path: 'edit_template', component: TemplateEditorComponent, canActivate: [AuthGuard] },
  { path: 'preview', component: PreviewPageComponent, canActivate: [AuthGuard] },
  { path: 'property', component: NewPropertyComponent, canActivate: [AuthGuard] },
  { path: 'filter', component: FilterComponent, canActivate: [AuthGuard] },
  { path: 'request_logs', component: RequestLogsComponent, canActivate: [AuthGuard] },
  { path: 'configuration', component: ConfigurationComponent, canActivate: [AuthGuard] },
  { path: 'introduction', component: GetStartedComponent, canActivate: [AuthGuard] },
  { path: 'tracking', component: TrackingComponent, canActivate: [AuthGuard] },
  { path: 'user_profile', component: UserProfileComponent, canActivate: [AuthGuard] },
  { path: 'user_setup', component: FirstTimeSetupComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'private-beta', component: WarmUpComponent },
  // { path: 'register', component: RegisterComponent },
  // { path: 'home', component: LandingComponent },
  // { path: 'features', component: FeaturesComponent },
  // { path: 'support', component: SupportComponent },
  // { path: 'why-us', component: WhychooseusComponent },
  // { path: 'updates', component: NewsComponent },
  // { path: 'pricing', component: PricingComponent },
  { path: 'onboarding', component: OnboardingComponent },
  // { path: '', redirectTo: '/dashboard', pathMatch: 'full', canActivate: [AuthGuard] },
  // { path: '', redirectTo: '/home', pathMatch: 'full' },
  // { path: '**', component: PageNotFoundComponent },
  { path: '**', component: WarmUpComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
